import { useLocation } from "react-router-dom";
import type { PushPathState } from "feat/globalRouter/performPush";
import { ScreenType } from "v2/renderers/rendererLocator";
import { useEffectiveScreenType } from "v2/state/screenTypeProvider";

/** useEffectiveScreenType, with the screen type taken from navigation state. */
export default function useDerivedScreenType(): ScreenType {
  const location = useLocation();
  // react-router types `state` as `any`, but the pushes that set it all go through pushPath.
  const state = location.state as PushPathState | null;
  return useEffectiveScreenType(state?.screenType as ScreenType | undefined);
}
